import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import {
  LeaderboardIcon,
  QuizzesIcon,
  NotificationIcon,
  UserIcon,
} from '../Icons'

import { Wrap, LinksWrap, LinkText, LinkWrap } from './styled'

import {
  NOTIFICATIONS,
  PROFILE,
  QUIZZES,
  QUIZZES_NEW,
  QUIZZES_COMPLETED,
  LEADER_BOARD,
} from 'src/constants/routes'
import { color } from 'src/styles'

const BottomNavigation: React.FC = () => {
  const { pathname } = useLocation()
  return (
    <Wrap>
      <LinksWrap>
        <li>
          <Link to={QUIZZES}>
            <LinkWrap>
              <QuizzesIcon
                fill={
                  [QUIZZES_NEW, QUIZZES_COMPLETED].includes(pathname)
                    ? color.DUSTY_ORANGE
                    : color.PINKISH_GREY
                }
              />
              <LinkText
                isActive={[QUIZZES_NEW, QUIZZES_COMPLETED].includes(pathname)}
              >
                Quizzes
              </LinkText>
            </LinkWrap>
          </Link>
        </li>
        <li>
          <Link to={LEADER_BOARD}>
            <LinkWrap>
              <LeaderboardIcon
                fill={
                  pathname === '/leaderboard'
                    ? color.DUSTY_ORANGE
                    : color.PINKISH_GREY
                }
              />
              <LinkText isActive={pathname === '/leaderboard'}>
                Leaderboard
              </LinkText>
            </LinkWrap>
          </Link>
        </li>
        <li>
          <Link to={NOTIFICATIONS}>
            <LinkWrap>
              <NotificationIcon
                fill={
                  pathname === NOTIFICATIONS
                    ? color.DUSTY_ORANGE
                    : color.PINKISH_GREY
                }
              />
              <LinkText isActive={pathname === NOTIFICATIONS}>
                Notifications
              </LinkText>
            </LinkWrap>
          </Link>
        </li>
        <li>
          <Link to={PROFILE}>
            <LinkWrap>
              <UserIcon
                fill={
                  pathname === PROFILE ? color.DUSTY_ORANGE : color.PINKISH_GREY
                }
              />
              <LinkText isActive={pathname === PROFILE}>Me</LinkText>
            </LinkWrap>
          </Link>
        </li>
      </LinksWrap>
    </Wrap>
  )
}

export default BottomNavigation
